module.exports = __webpack_public_path__ + "static/media/patient-ico-purple.3a6c6267.svg";